import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useCotizacionFactorajeStore = defineStore(
  "cotizacion-factoraje-store",
  () => {
    const initialState = {
      cliente: null,
      linea: null,
      monto_factura: null,
      aforo_porcentaje: null,
      comision_apertura: null,
      comision_disposicion: null,
      tasa: null,
      fecha_curse: null,
      fecha_pago: null,
      plazo: 90,
    };

    const state = ref({ ...initialState });

    // ID = monto_factura * (anticipo%)
    const aforo_cantidad = computed(() => {
      const monto = Number(state.value.monto_factura) || 0;
      const aforo_porcentaje = Number(state.value.aforo_porcentaje) || 0; // se asume viene como porcentaje: 30 = 30%
      if (!monto || !aforo_porcentaje) return 0;

      return monto * (aforo_porcentaje / 100);
    });

    // Tasa diaria = (rate * 12) / 360
    const tasaDiaria = computed(() => {
      const tasa = Number(state.value.tasa) || 0; // se asume tasa viene como porcentaje: 30 = 30%
      if (!tasa) return 0;
      return (tasa * 12) / 360;
    });

    // Tasa por plazo (en %)
    const tasaPorPlazo = computed(() => {
      if (!tasaDiaria.value) return 0;
      const plazo = Number(state.value.plazo) || 0;
      return tasaDiaria.value * plazo;
    });

    const comisionAperturaCantidad = computed(() => {
      if (!state.value.linea || isNaN(state.value.linea)) return 0;
      const ca = Number(state.value.comision_apertura / 100) || 0;
      return state.value.linea * ca;
    });

    const comisionDisposicionCantidad = computed(() => {
      const df = Number(state.value.comision_disposicion / 100) || 0;
      return aforo_cantidad.value * df;
    });

    const tasaCantidad = computed(() => {
      if (!tasaPorPlazo.value) return 0;
      return (tasaPorPlazo.value / 100) * aforo_cantidad.value;
    });

    // Monto a recibir (igual que la fórmula de Excel)
    const montoARecibir = computed(() => {
      const aforo_cantidad_value = aforo_cantidad.value;
      if (!aforo_cantidad_value) return 0;

      const plazo = Number(state.value.plazo) || 0;
      const tasa = Number(state.value.tasa) || 0;

      // Interés según fórmula de Excel:
      // (((C9*12)/360)*C11)*0.01 * C10
      const interes = ((tasa * 12) / 360) * plazo * 0.01 * aforo_cantidad_value;
      // Se asume ca y disbursment_fee ya son DECIMALES como en Excel (3% = 0.03)
      const ca = Number(state.value.comision_apertura / 100) || 0;
      const df = Number(state.value.comision_disposicion / 100) || 0;

      const comisionApertura = aforo_cantidad_value * ca;
      const disbursmentFee = aforo_cantidad_value * df;

      return aforo_cantidad_value - interes - comisionApertura - disbursmentFee;
    });

    return {
      initialState,
      state,
      aforo_cantidad,
      tasaDiaria,
      tasaPorPlazo,
      montoARecibir,
      comisionAperturaCantidad,
      comisionDisposicionCantidad,
      tasaCantidad,
    };
  }
);
